import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=db77068c&"
import script from "./Index.vue?vue&type=script&lang=js&"
export * from "./Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db77068c')) {
      api.createRecord('db77068c', component.options)
    } else {
      api.reload('db77068c', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=db77068c&", function () {
      api.rerender('db77068c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/googleSheet/Index.vue"
export default component.exports